import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import SocialMediaLinks from './SocialMediaLinks';

// Affiliate LifeWave Shop Link
const LIFEWAVE_SHOP_URL = 'https://lifewave.com/ioanaalexandra/store/products';

const footerTranslations = {
  en: { myStory: "My Story", contact: "Contact" },
  ro: { myStory: "Povestea Mea", contact: "Contact" },
  es: { myStory: "Mi Historia", contact: "Contacto" },
  it: { myStory: "La Mia Storia", contact: "Contatto" },
  de: { myStory: "Meine Geschichte", contact: "Kontakt" }
};

const Footer = () => {
  const { t, language } = useLanguage();
  const footerT = footerTranslations[language] || footerTranslations['en'];

  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-sky-500 to-sky-600 flex items-center justify-center">
                <span className="text-white font-bold text-lg">LW</span>
              </div>
              <span className="font-bold text-lg">Live Well~Live Good~Live Long</span>
            </div>
            <p className="text-slate-400 mb-4 max-w-md">
              {t('footerDescription')}
            </p>
            <button 
              onClick={() => window.open(LIFEWAVE_SHOP_URL, '_blank')}
              className="inline-flex items-center gap-2 text-sky-400 hover:text-sky-300 transition-colors mb-6"
            >
              <ExternalLink className="w-4 h-4" />
              {t('visitShop')}
            </button>
            
            {/* Social Media */}
            <div className="mt-4">
              <SocialMediaLinks variant="footer" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-sky-400 uppercase text-sm tracking-wide">{t('quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition-colors">
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-slate-400 hover:text-white transition-colors">
                  {t('products')}
                </Link>
              </li>
              <li>
                <Link to="/my-story" className="text-slate-400 hover:text-white transition-colors">
                  {footerT.myStory}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  {footerT.contact}
                </Link>
              </li>
              <li>
                <button 
                  onClick={() => window.open(LIFEWAVE_SHOP_URL, '_blank')}
                  className="text-slate-400 hover:text-white transition-colors flex items-center gap-1"
                >
                  {t('shopNow')} <ExternalLink className="w-3 h-3" />
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-sky-400 uppercase text-sm tracking-wide">{footerT.contact}</h4>
            <ul className="space-y-3">
              <li className="text-slate-400">
                <span className="block text-white font-medium">Ioana Alexandra</span>
                LifeWave Partner
              </li>
              <li className="text-slate-400">
                <span className="block text-white">+40 766 475 946</span>
                WhatsApp
              </li>
              <li className="text-slate-400">
                Romania, Europe
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="text-slate-500 text-sm space-y-2">
            <p>
              © {new Date().getFullYear()} Live Well~Live Good~Live Long by Ioana Alexandra. Independent LifeWave Partner.
            </p>
            <p className="text-xs">
              {t('footerDisclaimer')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
